<div class="modal__content">
  <div *ngIf="!isProcessing">
    <ng-container *ngIf="config.data.showConfidential; then confSection; else nonConfSection">
    </ng-container>
  </div>
  <ng-container *ngIf="isProcessing">
    <wfm-spinner [show]="true" [size]="40"></wfm-spinner>
  </ng-container>
</div>

<div class="flex flex--row flex--nowrap flex--middle flex--right u-mh- u-pt+ u-pb-">
  <span>
    <button id="patient-update-no-button"
            class="button button--tertiary u-mr-"
            (click)="onClose(false); $event.stopPropagation()"
            tabindex="2"
            [disabled]="isProcessing"
            [innerHTML]="'label.no' | translate">
      </button>
      <button  id="patient-update-yes-button"
               class="button button--primary"
              (click)="onClose(true); $event.stopPropagation()"
              [disabled]="isProcessing"
              tabindex="1"
              [innerHTML]="'label.yes' | translate">
      </button>
  </span>
</div>

<!-- Template for Mark Confidental -->
<ng-template #confSection>
  <div> {{ 'context.updateToConfidentialMsg' | translate }} </div>
  <div class="u-pt--">
    {{ 'context.confidential.workflowImpactedNote' | translate }}
    <ul class="u-pt---">
      <li> {{ 'assignments.assignmentsMsg' | translate }} </li>
      <li> {{ 'workloadManager.listContainer.label.designatedAuthor' | translate }} </li>
      <li> {{ 'label.coreader' | translate }} </li>
    </ul>
  </div>
  <div class="u-pt--"> {{ 'label.ask.wantToContinue' | translate }} </div>
</ng-template>

<!-- Template for Mark Non-Confidental -->
<ng-template #nonConfSection>
  <div> {{ 'context.updateToNotConfidentialMsg' | translate }} </div>
  <div class="u-pt--"> {{ 'label.ask.wantToContinue' | translate }} </div>
</ng-template>